import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
    settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions,
    settheTicketIDSActions,
    setZoneActions,
    setRegionActions,
    setGeoLoactionStateAction,
    setClientBranchSearchAction,
    setTheticketetailsExportActions,

    gettheinernalDashboardState,
    gettheinernalDashboardRegion,
    gettheinernalDashboardZone,
    gettheinernalDashboardPriority,
    gettheinernalDashboardStatus,
    gettheinernalDashboardbranch,

    setTheTicketingsystemtdashboardRange1,
    setTheTicketingsystemDashboardRange2,
    SetActiveTabs,
    setDashboardactiveTabs,
    getSideBarfilesActions,
    settheDefualtDatefilyer,
    settheTicketsystemrecordgetListInternalDataActions,

    settheTicketsystemrecordgetListInternalNearDueDataActions,
    settheTicketraiseroutes,
    settheInternalDepartmentsctions,
    gettheNearDueDepartmentsFilterStates,
    gettheinternalUsersTicketingRangesone, gettheinternalUsersTicketingRangesTwo,
    settheInternal_Statuss
} from "../../../../Redux/Slice";
import { NavLink, useNavigate } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { parseISO, addDays, differenceInDays } from "date-fns";
import { DateRangePicker } from "rsuite";
import { subDays, startOfYear, format } from "date-fns";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
// import { Chart } from "react-google-charts";
import Swal from "sweetalert2";
import _, { values } from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeclineIcon from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-31.svg";
import PendignIcons from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-32.svg";
import EmployeeIcons from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-33.svg";

import high from "../../../../Assets/AppComponent/Group 427319195.svg";
import low from "../../../../Assets/AppComponent/Group 427319196.svg";
import medimum from "../../../../Assets/AppComponent/Group 427319197.svg";

import ticketinprogressticker from "../../../../Assets/AppComponent/Group 427320006.svg";
import ticketresolvedticker from "../../../../Assets/AppComponent/Group 427320008.svg";
import ticketreviewsticker from "../../../../Assets/AppComponent/Group 427320007 (1).svg";


import TicketclientBox from "../../../../Assets/AppComponent/Group 427320114.svg";

import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";


import TicketIMAGES from "../../../../Assets/AppComponent/Group 427320097.svg";

import CalenderIMg from "../../../../Assets/AppComponent/CalendarBlank.svg";
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from "@mui/material";


import boximg from "../../../../Assets/AppComponent/Group 427320177.svg";
import SimpleBarChartInternal from "./SimpleBarChartInernal";
import useDebouncedEffect from 'use-debounced-effect';
import { Internal_dashboardTable } from "./Internal_dashboardTable/Internal_dashboardTable";
import { Statebasedinternaldash } from "./Internal_dashboardTable/Statebasedinternaldash";
import Internalescalationdash from "./Internal_dashboardTable/Internalescalationdash";
import DropdownIndicator from "../../../AppComponent/InputFields/DropdownIndicator";

const InternalDashboardusers = () => {
    const dispatch = useDispatch();
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    const formatDateFilter = (date) => format(date, "yyyy-MM-dd");

    const last30DaysRange = [formatDateFilter(subDays(new Date(), 29)), formatDateFilter(new Date())];
    const lastWeekRange = [formatDateFilter(subDays(new Date(), 6)), formatDateFilter(new Date())];
    const currentYearRange = [formatDateFilter(startOfYear(new Date())), formatDateFilter(new Date())];


    var UserTypeUds = localStorage.getItem("userdepartmentTypes");
    // var UserTypeUds = "l2"
    const [showTooltip, setShowTooltip] = useState(false);


    const state = useSelector((state) => state);
    const [multiselect1, setMuliselect1] = useState([state.ClientBranchIDs.InernalDashboardTicketSystem_Region,]);
    const [multiselect3, setMuliselect3] = useState([state.ClientBranchIDs.InernalDashboardTicketSystem_Zone,]);
    const [nameList5, setOptions5] = useState([]);
    const [Zone, setZone] = useState([]);

    const [datas, setData] = useState({
        zone: state.ClientBranchIDs.InernalDashboardTicketSystem_Zone?.value,
        state: state.ClientBranchIDs.InernalDashboardTicketSystem_State?.value,
        region: state.ClientBranchIDs.InernalDashboardTicketSystem_Region?.value,
    });
    const [multiselect, setMuliselect] = useState([state.ClientBranchIDs.InernalDashboardTicketSystem_State,]);
    ///--filter----------------
    let [nameList, setOptions] = useState([]);
    const [nameList2, setOptions2] = useState([]);
    const [Client, setClients] = useState(state.ClientBranchIDs.InernalDashboardTicketSystem_Branch?.value || "");
    const [nameList4, setOptions4] = useState([]);
    const [search, setSearch] = useState("");
    const [selectedValues, SetSelectValue] = useState([state.ClientBranchIDs.InernalDashboardTicketSystem_Branch]);

    

    const optionsStatus = [
        { value: "", label: "All" },
        { value: "0", label: "Open" },
        { value: "1", label: "In Progress" },
        { value: "3", label: "Review" },
        { value: "4", label: "Reopen" },
        { value: "2", label: "Close" },

    ];

    let Priorityoptions = [
        { value: "", label: "All" },
        { value: "0", label: "Low" },
        { value: "1", label: "Medium" },
        { value: "2", label: "High" },
    ];


    const [PriorityValues, setPriorityValues] = useState(state.ClientBranchIDs.InernalDashboardTicketSystem_Priority?.value)
    const [prioritySelect, setpriorityselect] = useState(state.ClientBranchIDs.InernalDashboardTicketSystem_Priority);
    const [Differentreminders, setremainingTime] = useState(1)
    const Navigate = useNavigate()

    

    useEffect(() => {
        if (DateFilters == "ThisWeek") {
            dispatch(gettheinternalUsersTicketingRangesone(lastWeekRange[0]));
            dispatch(gettheinternalUsersTicketingRangesTwo(lastWeekRange[1]));
        }
        else if (DateFilters == "ThisMonth") {
            dispatch(gettheinternalUsersTicketingRangesone(last30DaysRange[0]));
            dispatch(gettheinternalUsersTicketingRangesTwo(last30DaysRange[1]));
        }
        else {
            dispatch(gettheinternalUsersTicketingRangesone(currentYearRange[0]));
            dispatch(gettheinternalUsersTicketingRangesTwo(currentYearRange[1]));
        }
    }, [])

    const [SttausValues, setStatusValue] = useState(state.ClientBranchIDs.InernalDashboardTicketSystem_Status?.value);
    const [Statusopiotns, setStatusoptions] = useState(state.ClientBranchIDs.InernalDashboardTicketSystem_Status);

    var remainingTime
    const data = [
        { month: 'January', value: 10 },
        { month: 'February', value: 20 },
        { month: 'March', value: 30 },
        { month: 'April', value: 40 },
    ];

    const [UdsUsers, setUdsusers] = useState(0)
    ///----Filter-----------------------

    const initialStateSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);

    const initialDebouanceSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
        Clientsearch:""
    };
    
    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
    


    const [activeButton, setActiveButton] = useState("Open");

    const [downloadpopup, setdownloadpopup] = useState(false)


    const [DateFilters, setDateFilters] = useState(state.StateManagementOverallCall.DefualtDatefilyer)

    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    var it = convert(state.StateManagementOverallCall.TicketingsystemDashboardRange1);
    var gt = convert(state.StateManagementOverallCall.TicketingsystemDashboardRange2);
    var startweet = convert(startOfWeek(new Date()));
    var endweek = convert(endOfWeek(new Date()))
    const [range, setrange] = useState(
        state.StateManagementOverallCall.TicketingsystemDashboardRange1 == ""
            ? // [it, gt]
            [startweet, endweek]
            : [it, gt]
    );

    const handlechangedate = (value) => {
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        }
    };
    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            dispatch(setTheTicketingsystemtdashboardRange1(range[0]));
            dispatch(setTheTicketingsystemDashboardRange2(range[1]));
        }
    }, [range]);
    const [TicketListpoup, setticketlistPopup] = useState(false)

    // console.log(state.StateManagementOverallCall.TicketingsystemDashboardRange1, "TicketingsystemDashboardRange1", state.StateManagementOverallCall.TicketingsystemDashboardRange2);

    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }

    const capitalizeEachWord = (str) => {
        return str && typeof str === "string"
            ? str
                .split(" ") // Split the string into an array of words
                .map(
                    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                ) // Capitalize each word
                .join(" ") // Join the words back into a string
            : ""; // Return an empty string if the input is invalid
    };

    useEffect(() => {
        // if (range.length > 0 && !range.includes("NaN-aN-aN")) {

        const payloads = {
            state: datas.state,
            // zone: datas.zone,
            region: datas.region,
            // client: Client,
            department: Client,
            priority: PriorityValues,
            status: SttausValues,
            // status: SttausValues == "over_due" ? "" : SttausValues,
            // over_due: SttausValues == "over_due" ? true : false,

            // status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
            // activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "over_due",
            // from_date: range[0],
            // to_date: range[1],
            // range: true,
            date: DateFilters,
            chart_type: state.FormsIDList.DashboardNavtabs == 1 ? "ontimeclose" : "reopenrate",
            ticket_assign: true

        }

        dispatch(settheTicketsystemrecordgetListInternalDataActions(payloads))
        // }
    }, [, DateFilters, state.FormsIDList.DashboardNavtabs, datas, Client, PriorityValues,])


    useEffect(() => {
        // if (range.length > 0 && !range.includes("NaN-aN-aN")) {
        if (state.ClientBranchIDs.SUBROLE != 3) {
            const payload = {
                search: "",
                page_size: 20,
                page: 1,
                region: datas.region,
                // zone: datas.zone,
                state: datas.state,
                // zone: datas.zone,
                region: datas.region,
                // client: Client,
                department: Client,

                from_date: state.ClientBranchIDs.TicketingsysteminernalusersRange1,
                to_date: state.ClientBranchIDs.TicketingsysteminternalusersRange2,
                range: state.ClientBranchIDs.TicketingsysteminernalusersRange1 && state.ClientBranchIDs.TicketingsysteminternalusersRange2 ?  true : false,

                priority: PriorityValues,
                status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                    activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "",
                over_due: activeButton == "over_due" ? true : "",

                // status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                //     activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "Rejected" && "5",
                ticket_assign: true

            };
            dispatch(settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions(payload));
        }

        else if (TicketListpoup == true && state.ClientBranchIDs.SUBROLE == 3) {

            const payload = {
                search: "",
                page_size: 20,
                page: 1,
                region: datas.region,
                // zone: datas.zone,
                state: datas.state,
                // zone: datas.zone,
                region: datas.region,
                // client: Client,
                department: Client,

                from_date: state.ClientBranchIDs.TicketingsysteminernalusersRange1,
                to_date: state.ClientBranchIDs.TicketingsysteminternalusersRange2,
                range: true,
                priority: PriorityValues,
                status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                    activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "",
                // status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                //     activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "Rejected" && "5",
                ticket_assign: true,
                over_due: activeButton == "over_due" ? true : "",


            };
            dispatch(settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions(payload));


        }
    }, [datas, Client, PriorityValues, activeButton, TicketListpoup])



console.log(state.ClientBranchIDs.TicketingsysteminternalusersRange2 ,"state.ClientBranchIDs.TicketingsysteminternalusersRange2");

    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            const payload = {
                search: "",
                page_size: 20,
                page: 1,
                state: datas.state,
                // zone: datas.zone,
                region: datas.region,
                // client: Client,
                department: Client,
                priority: PriorityValues,
                // status: SttausValues,
                status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                    activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "",
                ticket_assign: true,
                over_due: activeButton == "over_due" ? true : "",
                date: DateFilters,


            };
            dispatch(settheTicketsystemrecordgetListInternalNearDueDataActions(payload));
        }
    }, [activeButton, PriorityValues, datas, Client]);


    // console.log(state.NeadueInternalTicketCalls.TicketingInternalNearduedata, "NeadueInternalTicketCalls");


    useEffect(() => {
        dispatch(gettheNearDueDepartmentsFilterStates({ value: "0", label: "Open" }))
    }, [])
    const handleButtonClick = (button) => {
        setActiveButton(button);
        if (button == "Open") {
            dispatch(gettheNearDueDepartmentsFilterStates({ value: "0", label: "Open" }))
        }
        else if (button == "Inprocess") {
            dispatch(gettheNearDueDepartmentsFilterStates({ value: "1", label: "In Progress" }))
        }
        else if (button == "Completed") {
            dispatch(gettheNearDueDepartmentsFilterStates({ value: "2", label: "Review" }))
        }
        else if (button == "Close") {
            dispatch(gettheNearDueDepartmentsFilterStates({ value: "3", label: "Resolved" }))
        }
        else if (button == "Reopen") {
            dispatch(gettheNearDueDepartmentsFilterStates({ value: "4", label: "Reopened" }))
        }
        else if (button == "over_due") {
            dispatch(gettheNearDueDepartmentsFilterStates({ value: "over_due", label: "Over Due" }))
        }


    };



    ///--------------State-----------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.stateSearch,
            page_size: "",
            page: 1,
        };
        dispatch(setGeoLoactionStateAction(payloads));
    }, [SearchedVal.stateSearch]);

    //--------------_Zone---------------
    // useEffect(() => {
    //     const payloads = {
    //         search: SearchedVal.zoneSearch,
    //         page_size: 20,
    //         page: 1,
    //         counts: 1,
    //         region_id: datas.region,
    //     };
    //     dispatch(setZoneActions(payloads));
    //     setZone(state.ZonePart.Zone);
    // }, [datas.region, SearchedVal.zoneSearch]);

    //-----Region---------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.regionSearch,
            page_size: 20,
            page: 1,
            counts: 1, //-----only we ----get----the----selected regions , the--id only
            state: datas.state,
        };
        dispatch(setRegionActions(payloads));
    }, [datas.state, SearchedVal.regionSearch]);



    // const datastate = { state: datas.state, region: datas.region, zone: datas.zone };
    // useEffect(() => {
    //     const payload = {
    //         search: search,
    //         page_size: 20,
    //         page: 1,
    //         data: datastate,
    //     };
    //     dispatch(setClientBranchSearchAction(payload));

    // }, [search, datas]);

    useEffect(() => {
        if (state.GeoState.State != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.GeoState.State.forEach((element) => {
                objectArray.push({ value: element.id, label: capitalizeEachWord(element.state_name.toLowerCase()) });
            });

            // console.log(objectArray , "objectArray");
            setOptions(objectArray);
        }
    }, [state.GeoState.State, SearchedVal.stateSearch]);




    useEffect(() => {
        // if(datas.state !="" && datas.region !="" && datas.zone !=""){ 
        const payload = {
            search: search,
            page_size: 20,
            page: 1,
            state: datas.state,
            region: datas.region
        };
        setTimeout(() => {
            // dispatch(setClientBranchSearchAction(payload));
            dispatch(settheInternalDepartmentsctions(payload))
        }, 400);
    }, [search, datas.state, datas.region]);


    useEffect(() => {
        if (state?.InternalSubDepartmentsDatas?.internalDepartmentDatas != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state?.InternalSubDepartmentsDatas?.internalDepartmentDatas.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.department_name,
                });
            });
            setOptions4(objectArray);
        }
    }, [state?.InternalSubDepartmentsDatas?.internalDepartmentDatas, search]);

    // useEffect(() => {
    //     if (state.BranchSearchpart.BranchSearch != undefined) {
    //         let objectArray = [];
    //         objectArray.push({ value: "", label: "All" });
    //         state.BranchSearchpart.BranchSearch.forEach((element) => {
    //             objectArray.push({
    //                 value: element.id,
    //                 label: capitalizeEachWord(element.client_name.toLowerCase()),
    //             });
    //         });
    //         setOptions4(objectArray);
    //     }
    // }, [state.BranchSearchpart.BranchSearch, search]);


    ///  ///----------------------REgion-----------
    useEffect(() => {
        if (state.regioncall.RegionDat != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.regioncall.RegionDat.forEach((element) => {
                objectArray.push({ value: element.id, label: capitalizeEachWord(element.region_name.toLowerCase()) });
            });

            setOptions2(objectArray);
        }
    }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

    const HandleInputBranch = (e) => {
        setSearchDebounance({
            ...SearchDebounance,
            Clientsearch:e
          
          })    };

    //----Region----------------
    const handelRegionSlect = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect1(selectedVal);
            setMuliselect3({ value: "", label: "All" });
            SetSelectValue({value: "", label: "All" })

            setData({
                ...datas,
                region: selectedVal.value,
            });
            dispatch(gettheinernalDashboardRegion(selectedVal));

            dispatch(gettheinernalDashboardZone({ value: "", label: "All" }));
            dispatch(gettheinernalDashboardbranch({ value: "", label: "All" }))

        }
        if (selectedVal == null) {
            setData({
                ...datas,
                region: "",
                zone: "",
            });
            dispatch(gettheinernalDashboardRegion([]));
            dispatch(gettheinernalDashboardbranch({ value: "", label: "All" }))
            SetSelectValue({value: "", label: "All" })

            dispatch(gettheinernalDashboardZone({ value: "", label: "All" }));


            setMuliselect3({ value: "", label: "All" });
            setMuliselect1([]);
        }
                    setClients("");

    };
    //----------------Zone
    const handleZone = (selectedVal) => {
        //console.log(selectedVal ,"selected Values");
        if (selectedVal != null) {
            setMuliselect3(selectedVal);
            setData({
                ...datas,
                zone: selectedVal.value,
            });

            dispatch(gettheinernalDashboardZone(selectedVal));

        }
        if (selectedVal == null) {
            setData({
                ...datas,
                zone: "",
            });

            dispatch(gettheinernalDashboardZone({ value: "", label: "All" }));

            setMuliselect3({ value: "", label: "All" });
        }
    };
    const handleSelectChange = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect(selectedVal);
            setMuliselect1({ value: "", label: "All" });
            setMuliselect3({ value: "", label: "All" });
            SetSelectValue({value: "", label: "All" })

            setData({
                ...datas,
                state: selectedVal.value,
                zone: "",
                region: "",
            });

            setClients("");

            dispatch(gettheinernalDashboardState(selectedVal));



        }
        if (selectedVal == null) {
            setMuliselect({ value: "", label: "All" });
            setMuliselect1({ value: "", label: "All" });
            setMuliselect3({ value: "", label: "All" });
            SetSelectValue({value: "", label: "All" })
            setData({
                ...datas,
                state: "",
                zone: "",
                region: "",
            });
            setClients("");

            dispatch(gettheinernalDashboardState({ value: "", label: "All" }));

        }

        dispatch(gettheinernalDashboardRegion({ value: "", label: "All" }));

        dispatch(gettheinernalDashboardZone({ value: "", label: "All" }));
        dispatch(gettheinernalDashboardbranch({ value: "", label: "All" }));


    };
    ///-------------Zone--------------
    useEffect(() => {
        if (state.ZonePart.Zone != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.ZonePart.Zone.forEach((element) => {
                objectArray.push({ value: element.id, label: capitalizeEachWord(element.zone_name.toLowerCase()) });
            });
            setOptions5(objectArray);
        }
    }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

    const HandleClientBranches = (selectedVal) => {

        if (selectedVal != null) {
            dispatch(gettheinernalDashboardbranch(selectedVal));

            SetSelectValue(selectedVal);
            setClients(selectedVal.value);
            SetSelectValue(selectedVal);
        }
        else {

            dispatch(gettheinernalDashboardbranch({ value: '', label: "All" }));

            SetSelectValue([]);
            setClients("");
            SetSelectValue([]);
        }
    };


    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...SearchedVal,
                    stateSearch: SearchDebounance.stateSearch,
                    regionSearch: SearchDebounance.regionSearch,
                    zoneSearch: SearchDebounance.zoneSearch,
                });
               setSearch(SearchDebounance.Clientsearch)
            }
        },
        500,
        [SearchDebounance]
    );
    
    ///-----State----Input Changes
    const handleInputChange = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            stateSearch: Val,
    
        });
    
    };
    
    ///---Region-----------------
    const handleInputRegion = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            regionSearch: Val,
        });
    };
    ///----Zone---Name
    const handleInputZone = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            zoneSearch: Val,
        });
    };
    
    const HandleTheExports = () => {
        const payloads = {
            ticketapis: 2,
            parasnadata: {
                // state: datas.state,
                // zone: datas.zone,
                // region: datas.region,
                // client: Client,
                // priority: PriorityValues,
                // status: SttausValues,
                state: datas.state,
                // zone: datas.zone,
                region: datas.region,
                // client: Client,
                department: Client,
                priority: PriorityValues,
                status: SttausValues,
                // status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                    // activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "over_due",
                // from_date: range[0],
                // to_date: range[1],
                // range: true,
                date: DateFilters,
                chart_type: state.FormsIDList.DashboardNavtabs == 1 ? "ontimeclose" : "reopenrate",
                ticket_assign: true

            }

        }
        dispatch(setTheticketetailsExportActions(payloads))
        setdownloadpopup(false);

    }
console.log(activeButton ,"activeButton",Statusopiotns);

    const MoveTotheNextTab = () => {
        dispatch(getSideBarfilesActions("Assigned Tickets"));

        if (activeButton == "All") {
            dispatch(settheInternal_Statuss({ value: "", label: "All" }))

        }
        else if (activeButton == "Open") {
            dispatch(settheInternal_Statuss({ value: "0", label: "Open" }))
        }
        else if (activeButton == "Inprocess") {
            dispatch(settheInternal_Statuss({ value: "1", label: "In Progress" }))
        }
        else if (activeButton == "Completed") {
            dispatch(settheInternal_Statuss({ value: "2", label: "Review" }))
        }
        else if (activeButton == "Close") {
            dispatch(settheInternal_Statuss({ value: "3", label: "Resolved" }))
        }
        else if (activeButton == "Reopen") {
            dispatch(settheInternal_Statuss({ value: "4", label: "Reopened" }))
        }
        else if (activeButton == "over_due") {
            dispatch(settheInternal_Statuss({ value: "over_due", label: "Over Due" }))
        }

        if (DateFilters == "ThisWeek") {
            dispatch(gettheinternalUsersTicketingRangesone(lastWeekRange[0]));
            dispatch(gettheinternalUsersTicketingRangesTwo(lastWeekRange[1]));
        }
        else if (DateFilters == "ThisMonth") {
            dispatch(gettheinternalUsersTicketingRangesone(last30DaysRange[0]));
            dispatch(gettheinternalUsersTicketingRangesTwo(last30DaysRange[1]));
        }
        else {
            dispatch(gettheinternalUsersTicketingRangesone(currentYearRange[0]));
            dispatch(gettheinternalUsersTicketingRangesTwo(currentYearRange[1]));
        }

        Navigate("/internalTicketuserlist");
    }

    const MoveTotheNextNeardue = () => {
        Navigate("/neardue_internal");
    }
    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        return `${day} / ${month} / ${year}`;
    };

    const HandleTheNeardueTickets = (datas) => {
        dispatch(settheTicketIDSActions(datas.id)); /// ticket id
        // dispatch(getSideBarfilesActions("Tickets"));
        // Navigate("/ticketviews")
        dispatch(settheTicketraiseroutes(4))
        Navigate("/internal_ticketview")

    }
    function overdueFunctionspercentanges(item) {
        console.log(item, "sadiuasidu item");

        const overdueMinutes = (item / 100);

        return overdueMinutes;

    }


    const overdueFunctions = (ticketretrieve) => {
        const convertToMinutes = (days, hours, minutes) => (days * 24 * 60) + (hours * 60) + minutes;
        let differenceInMinutes

        function calculateTimeStatus(differenceInMinutes) {
            console.log(differenceInMinutes, 'differenceInMinutes');

            if (differenceInMinutes > 0 || differenceInMinutes == 0) {
                return "Overdue";
            }

            if (Math.abs(differenceInMinutes) >= 1440) {
                // More than or equal to 1 day
                const days = Math.floor(Math.abs(differenceInMinutes) / (60 * 24));
                return `${days} Days left`;
            }

            if (Math.abs(differenceInMinutes) >= 60) {
                // More than or equal to 1 hour
                const hours = Math.floor(Math.abs(differenceInMinutes) / 60);
                return `${hours} Hours left`;
            }

            // Less than 1 hour
            const minutes = differenceInMinutes * -1;
            return `Minutes left ${minutes}`;
        }
        var remainingTimevalues


        const formatTime = (ms) => {
            const days = Math.floor(ms / (1000 * 60 * 60 * 24));
            const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
            return { days, hours, minutes };
        };

        const formatTimeLevel = (ms, Levelonbetypes) => {
            return {
                days: Levelonbetypes === "2" ? ms : 0,
                hours: Levelonbetypes === "1" ? ms : 0,
                minutes: Levelonbetypes === "0" ? ms : 0,
            };
        };

        if (ticketretrieve?.created_at && ticketretrieve?.department_users?.l1_user_TAT) {
            const createdDate = new Date(ticketretrieve.created_at);
            const currentDate = new Date();
            const differenceInMs = currentDate - createdDate;

            const timeDifference = formatTime(differenceInMs);

            const LevelonbeTAT = Number(ticketretrieve.department_users.l1_user_TAT);
            const Levelonbetypes = ticketretrieve.department_users.l1_time_type;

            const period1Minutes = convertToMinutes(
                timeDifference.days,
                timeDifference.hours,
                timeDifference.minutes
            );

            const period2Minutes = convertToMinutes(
                Levelonbetypes === "2" ? LevelonbeTAT : 0,
                Levelonbetypes === "1" ? LevelonbeTAT : 0,
                Levelonbetypes === "0" ? LevelonbeTAT : 0
            );

            differenceInMinutes = period1Minutes - period2Minutes;
            remainingTimevalues = calculateTimeStatus(differenceInMinutes);
            console.log(differenceInMinutes, " asdasdasd differenceInMnutes", differenceInMinutes > 0, remainingTimevalues);
            // Convert the difference back to days, hours, and minutes
            // Debugging log




            overdueFunctionspercentanges(differenceInMinutes * -1)

            return remainingTimevalues

            // return `${differenceInMinutes > 0 || isNaN(differenceInMinutes) ?

            //     "Overdue" :
            //     `Minutes left ${differenceInMinutes * -1}`}`;
        }

        return remainingTimevalues


    };


    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };


    useEffect(() => {
        dispatch(settheTicketraiseroutes(4))
    }, [])
    return (


        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "4px 10px" }}
                >
                    <div
                        class="col-12 "
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            height: "76px"
                        }}
                    >
                        <h3
                            className="TicketDasboardHeader">Dashboard</h3>

                        <div className="FilterofTicketDashboards" style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center" }}>
                            <button className={`DateFiltersTicket ${DateFilters == "ThisWeek" ? "Active" : ""}`}
                                onClick={() => {
                                    dispatch(settheDefualtDatefilyer("ThisWeek"))
                                    dispatch(gettheinternalUsersTicketingRangesone(lastWeekRange[0]));
                                    dispatch(gettheinternalUsersTicketingRangesTwo(lastWeekRange[1]));
                        
                                    setDateFilters("ThisWeek");
                                }}
                            >7 Days</button>
                            <button className={`DateFiltersTicket ${DateFilters == "ThisMonth" ? "Active" : ""}`}
                                onClick={() => {
                                    dispatch(settheDefualtDatefilyer("ThisMonth"));
                                    dispatch(gettheinternalUsersTicketingRangesone(last30DaysRange[0]));
                                    dispatch(gettheinternalUsersTicketingRangesTwo(last30DaysRange[1]));                        
                                    setDateFilters("ThisMonth")
                                }}
                            >Month</button>
                            <button className={`DateFiltersTicket ${DateFilters == "ThisYear" ? "Active" : ""}`}
                                onClick={() => {
                                    dispatch(settheDefualtDatefilyer("ThisYear"))
                                    dispatch(gettheinternalUsersTicketingRangesone(currentYearRange[0]));
                                    dispatch(gettheinternalUsersTicketingRangesTwo(currentYearRange[1]));                        
                                    setDateFilters("ThisYear")
                                }}
                            >Year</button>

                            <div className="" >
                                <button
                                    align="center"
                                    type="button"
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        background: "transparent",
                                    }}
                                    className="DownloadBTNS"
                                    onClick={(e) => {
                                        HandleTheExports()
                                        // setdownloadpopup(true)
                                    }}
                                >
                                    <a class="dnbtn"></a>
                                </button>

                            </div>

                        </div>


                    </div>


                </div>

                <div
                    className="row  Filtersdashboardstatus "

                >
                    <div
                        className="col-sm-2"
                    >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            State
                        </label>
                        <Select
                            className="Selectsfilter"
                            styles={{ position: "relative", top: "60px" }}

                            onChange={(e) => {
                                handleSelectChange(e);
                            }}
                                  components={{ DropdownIndicator:  DropdownIndicator }}
                            options={nameList}
                            onInputChange={handleInputChange}
                            onremoved={(e) => {
                                setMuliselect({ value: "", label: "All" });
                                console.log(e, "jjk9090");
                            }}
                            value={multiselect}
                                                        isClearable={true}

                            labelledBy="Select"
                        />
                    </div>

                    <div
                        className="col-sm-2" >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Region
                        </label>
                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect1(e)}
                            onChange={(e) => {
                                handelRegionSlect(e);
                            }}
                                  components={{ DropdownIndicator:  DropdownIndicator }}
                            options={nameList2}
                            labelledBy="Select"
                            isClearable={true}
                            onremoved={(e) => {
                                setMuliselect1(e);
                            }}
                            value={multiselect1}
                            onInputChange={handleInputRegion}
                        />
                    </div>

                    {/* <div
                        className="col-sm-2" >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Zone
                        </label>
                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect3(e)}
                            onChange={(e) => {
                                handleZone(e);
                            }}
                            value={multiselect3}
                            options={nameList5}
                            isClearable={true}
                            onremoved={(e) => {
                                setMuliselect3(e);
                                console.log(e, "jjk9090");
                            }}
                            labelledBy="Select"
                            onInputChange={handleInputZone}
                        />
                    </div> */}

                    <div
                        className="col-sm-2">
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Department
                        </label>
                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                HandleClientBranches(e);
                            }}
                                  components={{ DropdownIndicator:  DropdownIndicator }}
                            options={nameList4}
                            labelledBy="Select"
                            onInputChange={HandleInputBranch}
                            isClearable={true}
                            value={selectedValues}
                        />
                    </div>
                    <div
                        className="col-sm-2"

                    >
                        <label
                            class="form-label"

                        >
                            Priority
                        </label>

                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}

                            placeholder="search"
                            options={Priorityoptions}
                            onChange={(e) => {
                                if(e != null){ 
                                setpriorityselect(e)
                                setPriorityValues(e.value)
                                dispatch(gettheinernalDashboardPriority(e))
                                }
                                else {
                                    setpriorityselect(null)
                                setPriorityValues("")
                                dispatch(gettheinernalDashboardPriority([]))
                                }
                            }}

                                  components={{ DropdownIndicator:  DropdownIndicator }}
                            value={prioritySelect}
                                                        isClearable={true}

                        />
                    </div>

                    <div
                        className="col-sm-2"

                    >
                        <label
                            class="form-label"

                        >
                            Status
                        </label>

                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}

                            placeholder="search"
                            options={optionsStatus}
                            onChange={(e) => {
if(e != null ){
                                    setStatusoptions(e)
                                setStatusValue(e.value)
                                dispatch(gettheinernalDashboardStatus(e))
}
else {
                                    setStatusoptions(null)
                                setStatusValue("")
                                dispatch(gettheinernalDashboardStatus([]))
}
                            }}
                                  components={{ DropdownIndicator:  DropdownIndicator }}
                            value={Statusopiotns}
                                                        isClearable={true}

                        />
                    </div>

                </div>


                {
                    // UserTypeUds != "l2" 
                    state.ClientBranchIDs.SUBROLE == 3
                        ?
                        <div className="col-12 DashboardOverviewticketingforadmin">
                            <div
                                className="row TicketingDashboard TicketingDashboardforadmin"
                                style={{ marginBottom: "44px", padding: "0" }}
                            >

                                <div
                                    className="col-sm-2"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                    }}

                                >
                                    <div
                                        className="card Dashboard01"
                                        style={{
                                            borderRadius: "7px",
                                            border: "none",
                                            cursor: state.ClientBranchIDs.SUBROLE == 3 ? "pointer" : "none"
                                        }}
                                        onClick={() => {
                                            if (state.ClientBranchIDs.SUBROLE == 3) {
                                                handleButtonClick("All")
                                                setticketlistPopup(true)
                                            }
                                        }
                                        }
                                    >
                                        <div
                                            className="card-Body TicketDashboardCardBody"

                                        >
                                            <div className="InnerCardofTicket">
                                                <div
                                                    className=" iconsEmpVer">

                                                    <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                </div>

                                                <div
                                                    className="Counts"
                                                    style={{
                                                        fontSize: "30px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        // width: "126px"
                                                    }}
                                                >
                                                    <span
                                                    >
                                                        Total Tickets
                                                    </span>
                                                </div>
                                            </div>


                                            <div className="CountsOftickets">
                                                <span
                                                    className="DashboardCardHeader"
                                                >
                                                    {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata?.total_count ?
                                                        state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata?.total_count :
                                                        "0"
                                                    }

                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="col-sm-2"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                    }}

                                >
                                    <div
                                        className="card Dashboard01"
                                        style={{
                                            borderRadius: "7px",
                                            border: "none",
                                            cursor: state.ClientBranchIDs.SUBROLE == 3 ? "pointer" : "none"

                                        }}
                                        onClick={() => {
                                            if (state.ClientBranchIDs.SUBROLE == 3) {
                                                handleButtonClick("Close")
                                                setticketlistPopup(true)
                                            }
                                        }
                                        }
                                    >
                                        <div
                                            className="card-Body TicketDashboardCardBody"

                                        >
                                            <div className="InnerCardofTicket">
                                                <div
                                                    className=" iconsEmpVer">

                                                    <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                </div>

                                                <div
                                                    className="Counts"
                                                    style={{
                                                        fontSize: "30px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        // width: "126px"
                                                    }}
                                                >
                                                    <span
                                                    >
                                                        Resolved Tickets
                                                    </span>
                                                </div>
                                            </div>


                                            <div className="CountsOftickets">
                                                <span
                                                    className="DashboardCardHeader"
                                                >
                                                    {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata?.close_ticketing_count ?
                                                        state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata?.close_ticketing_count :
                                                        "0"
                                                    }

                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="unresolved-tickets">
                                    <div
                                        className="Collist"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",

                                        }}

                                    >
                                        <div
                                            className="card Dashboard01"
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: state.ClientBranchIDs.SUBROLE == 3 ? "pointer" : "none"

                                            }}
                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Open")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }
                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Unresolved Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.unresolved_tickets ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.unresolved_tickets :
                                                            "0"
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="Innerdetails">
                                            <div className={`detail-item ${state.ClientBranchIDs.SUBROLE == 3 ? "adminAccesstabs" : ""}`}
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Open")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }


                                            >
                                                <span className="count">{state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.open_ticketing_count ?
                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.open_ticketing_count :
                                                    "0"
                                                }</span>
                                                <span className="label open">Open</span>
                                            </div>
                                            <div className={`detail-item ${state.ClientBranchIDs.SUBROLE == 3 ? "adminAccesstabs" : ""}`}
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Inprocess")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }
                                            >
                                                <span className="count">{state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.inprocess_ticketing_count ?
                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.inprocess_ticketing_count :
                                                    "0"
                                                }</span>
                                                <span className="label in-progress">In Progress</span>
                                            </div>
                                            <div className={`detail-item ${state.ClientBranchIDs.SUBROLE == 3 ? "adminAccesstabs" : ""}`}
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Completed")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }

                                            >
                                                <span className="count">{state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.review_tickets_count ?
                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.review_tickets_count :
                                                    "0"
                                                }</span>
                                                <span className="label review">Review</span>
                                            </div>
                                            <div className={`detail-item ${state.ClientBranchIDs.SUBROLE == 3 ? "adminAccesstabs" : ""}`}
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Reopen")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }

                                            >
                                                <span className="count">{state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.reopen_ticketing_count ?
                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.reopen_ticketing_count :
                                                    "0"
                                                }</span>
                                                <span className="label reopen">Reopen</span>
                                            </div>
                                            <div className="detail-item">
                                                {/* <span className="count">05</span> */}
                                                <span className="count">{state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.over_due_ticket_count ?
                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.over_due_ticket_count :
                                                    "0"
                                                }</span>
                                                <span className="label overdue">Overdue</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>




                            </div>
                        </div>

                        :

                        UserTypeUds == "l2" || UserTypeUds == "l3" ?
                            <div className="col-12 DashboardOverviewticketing">
                                <div
                                    className="row TicketingDashboard"
                                    style={{ marginBottom: "44px" }}
                                >

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "All" ? "active-card" : ""
                                                }`}


                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}
                                            onClick={() => {
                                                handleButtonClick("All")
                                            }
                                            }
                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Total Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.total_count ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.total_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "Open" ? "active-card" : ""
                                                }`}
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                            }}

                                            onClick={() => {
                                                // if (state.ClientBranchIDs.SUBROLE == 3) {
                                                setticketlistPopup(true)
                                                // }
                                            }
                                            }

                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            New Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.new_tickets ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.new_tickets :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            className="card Dashboard01"
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                            }}
                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Escalated Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.escalated_tickets ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.escalated_tickets :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "over_due" ? "active-card" : ""
                                                }`}
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                            }}

                                            onClick={() => {
                                                handleButtonClick("over_due")
                                            }
                                            }


                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Overdue Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.over_due_ticket_count ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.over_due_ticket_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            className={`card Dashboard01 ${activeButton === "Completed" ? "active-card" : ""
                                                }`}

                                            // className="card Dashboard01"
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => {
                                                handleButtonClick("Completed")
                                            }
                                            }
                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Review Ticket
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.review_tickets_count ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.review_tickets_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>







                                </div>
                            </div>
                            :
                            <div className="col-12 DashboardOverviewticketing">
                                <div
                                    className="row TicketingDashboard"
                                    style={{ marginBottom: "44px" }}
                                >

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            className={`card Dashboard01 ${activeButton === "over_due" ? "active-card" : ""
                                                }`}
                                            // className="card Dashboard01"
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}
                                            onClick={() => {
                                                handleButtonClick("over_due")
                                            }
                                            }
                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Over Due Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.over_due_ticket_count ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.over_due_ticket_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "Open" ? "active-card" : ""
                                                }`}
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}
                                            onClick={() => {
                                                handleButtonClick("Open")
                                            }
                                            }

                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket"
                                                >
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Open Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.open_ticketing_count ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.open_ticketing_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "Inprocess" ? "active-card" : ""
                                                }`}
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}
                                            onClick={() => {
                                                handleButtonClick("Inprocess")
                                            }
                                            }

                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            In Progress Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.inprocess_ticketing_count ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.inprocess_ticketing_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "Completed" ? "active-card" : ""
                                                }`}
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}
                                            onClick={() => {
                                                handleButtonClick("Completed")
                                            }
                                            }


                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Review Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.review_tickets_count ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.review_tickets_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            className={`card Dashboard01 ${activeButton === "Close" ? "active-card" : ""
                                                }`}
                                            // className="card Dashboard01"
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}

                                            onClick={() => {
                                                handleButtonClick("Close")
                                            }
                                            }


                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Resolved Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.resolved_tickets ?
                                                            state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.resolved_tickets :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>







                                </div>
                            </div>
                }

                <div className="row RecentTicket mt-4">

                    <div className="col RecentcardTickets mb-3">
                        {state.ClientBranchIDs.SUBROLE == 3
                            ?

                            <div className="card TicketClientDeatils shadow-sm  mb-3" style={{ borderRadius: "none" }}>
                                <div className="row align-items-center">

                                    <div className="col-12 Ticketingrecords">




                                        <div className="ticket-activity ">

                                            <div className='ToggleOFTicketActive'>

                                                <ul className="nav nav-tabs" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button

                                                            className={`  nav-link  ${state.FormsIDList.DashboardNavtabs == 1 ? "active" : ""
                                                                }`}
                                                            id="ex3-tab-1"
                                                            data-bs-toggle="tab"
                                                            href="#ex3-tabs-1"
                                                            role="tab"
                                                            aria-controls="ex3-tabs-1"
                                                            aria-selected={state.FormsIDList.DashboardNavtabs == 1}
                                                            onClick={() => {
                                                                dispatch(setDashboardactiveTabs(1));

                                                            }}
                                                        >
                                                            On Time Closure
                                                        </button>
                                                    </li>


                                                    <li className="nav-item" role="presentation">

                                                        <button
                                                            className={`   nav-link  ${state.FormsIDList.DashboardNavtabs == 2 ? "active" : ""
                                                                }`}
                                                            id="ex3-tab-3"
                                                            data-bs-toggle="tab"
                                                            href="#ex3-tabs-3"
                                                            role="tab"
                                                            aria-controls="ex3-tabs-3"
                                                            aria-selected={state.FormsIDList.DashboardNavtabs == 2}
                                                            onClick={() => {
                                                                dispatch(setDashboardactiveTabs(2));

                                                            }}
                                                        >Reopen Rate</button>
                                                    </li>

                                                </ul>
                                            </div>


                                            <>
                                                <div className="tab-content TicketContnent" id="ex2-content">
                                                    <div className={`  tab-pane fade show   ${state.FormsIDList.DashboardNavtabs == 1
                                                        ? "active "
                                                        : ""
                                                        }`}
                                                        id="ex3-tabs-1"
                                                        role="tabpanel"
                                                        aria-labelledby="ex3-tab-1">


                                                        <div className="HeaderofOntime">
                                                            <h5>Overall Percentage</h5>
                                                            <span>{

                                                                state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.overall_percentage != undefined &&
                                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.overall_percentage != null &&
                                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.overall_percentage != 0 ?
                                                                    Math.round(state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.overall_percentage) : 0}%</span>
                                                        </div>



                                                        <div style={{ width: "96%", height: "360px", padding: "7", marginTop: "4px", }}>

                                                            {state.TicketingInertnalDashboardCalls?.TicketingInternalDashboarddata?.GraphData &&
                                                                (
                                                                    // Check if GraphData is not a single 0 or an array with only 0s
                                                                    Array.isArray(state.TicketingInertnalDashboardCalls?.TicketingInternalDashboarddata?.GraphData)
                                                                        ? state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata?.GraphData.some(value => value !== 0)
                                                                        : state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata?.GraphData !== 0
                                                                ) ? (
                                                                <SimpleBarChartInternal DateFilters={DateFilters} />
                                                            ) : (
                                                                <div>
                                                                    <div className="Dusbinback">
                                                                        <div>
                                                                            <img src={boximg} alt="No data available" />
                                                                            <p className="text-center">{"No data available"}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                            }




                                                        </div>
                                                    </div>


                                                    <div className={`  tab-pane fade show   ${state.FormsIDList.DashboardNavtabs == 2
                                                        ? "active "
                                                        : ""
                                                        }`}
                                                        id="ex3-tabs-3"
                                                        role="tabpanel"
                                                        aria-labelledby="ex3-tab-3">


                                                        <div className="HeaderofOntime">
                                                            <h5>Reopen Percentage</h5>
                                                            <span>{

                                                                state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.overall_percentage != undefined &&
                                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.overall_percentage != null &&
                                                                    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.overall_percentage != 0 ?
                                                                    Math.round(state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata.overall_percentage) : 0}%</span>
                                                        </div>


                                                        <div style={{ width: "96%", height: "360px", padding: "7", marginTop: "4px", }}>


                                                            {state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData &&
                                                                (
                                                                    // Check if GraphData is not a single 0 or an array with only 0s
                                                                    Array.isArray(state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData)
                                                                        ? state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData.some(value => value !== 0)
                                                                        : state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData !== 0
                                                                ) ? (
                                                                <SimpleBarChartInternal DateFilters={DateFilters} />
                                                            ) : (
                                                                <div>
                                                                    <div className="Dusbinback">
                                                                        <div>
                                                                            <img src={boximg} alt="No data available" />
                                                                            <p className="text-center">{"No data available"}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                            }


                                                        </div>

                                                    </div>
                                                </div>
                                            </>

                                        </div>


                                    </div>


                                </div>
                            </div>
                            :
                            <>
                                <div className="card p-3">

                                    <div className='TickerSTatementHeaders'>
                                        <h5>Ticket Summary</h5>
                                        <button onClick={() => MoveTotheNextTab()}>View All</button>
                                    </div>

                                    <p className='Borderpara'></p>
                                    <div className="Groupbtn mb-3">
                                        <button
                                            className={`btn ${activeButton === "All" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("All")}
                                        >
                                            All
                                        </button>
                                        <button
                                            className={`btn ${activeButton === "Open" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Open")}
                                        >
                                            Open
                                        </button>
                                        <button
                                            className={`btn ${activeButton === "Inprocess" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Inprocess")}
                                        >
                                            In Progress
                                        </button>



                                        <button
                                            className={`btn ${activeButton === "Completed" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Completed")}
                                        >
                                            Review
                                        </button>

                                        <button
                                            className={`btn ${activeButton === "over_due" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("over_due")}
                                        >
                                            Over Due
                                        </button>

                                        <button
                                            className={`btn ${activeButton === "Rejected" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Rejected")}
                                        >
                                            Rejected
                                        </button>


                                        <button
                                            className={`btn ${activeButton === "Reopen" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Reopen")}
                                        >
                                            Reopened
                                        </button>

                                        <button
                                            className={`btn ${activeButton === "Close" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Close")}
                                        >
                                            Resolved
                                        </button>
                                    </div>



                                    <div className='ContainsTickets'>

                                        {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.length != 0 ?
                                            <>
                                                {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData != undefined && state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.map((item, index) => {
                                                    const ticketid = item.id;
                                                    const lastFourDigits = item?.ticket_number;


                                                    return (
                                                        <>
                                                            <div className='containsticketprocess mt-3' key={index}
                                                                onClick={() => { HandleTheNeardueTickets(item) }}
                                                            >
                                                                <span className="priority-label inprocess"

                                                                    style={{
                                                                        background: item.status == 0 ? "hsla(170, 75%, 41%, 1)" : // Open - light background
                                                                            item.status == 1 ? "hsla(32, 92%, 59%, 1)" : // In Progress - yellow background
                                                                                item.status == 2 ? "hsla(170, 75%, 41%, 1)" : // Completed - light green background
                                                                                    item.status == 3 ? "hsla(140, 82%, 39%, 1)" : // Close - light green background for Close
                                                                                        "hsla(11, 85%, 54%, 1)", // Default for Reopen - light red background
                                                                        color: "#fff",
                                                                    }}

                                                                >

                                                                    {item.status == 0 ? "Open" :
                                                                        item.status == 1 ? "In Progress" :
                                                                            item.status == 2 ? "Review" :
                                                                                item.status == 3 ? "Resolved" : "Reopened"}</span>

                                                                {item.status == 3 ? null :

                                                                    <span className="OverDuedashboardparts">
                                                                        {overdueFunctions(item)}
                                                                    </span>
                                                                }


                                                                <div className="ticket-item mb-2">

                                                                    <div className="PriorityImgs" >
                                                                        <img
                                                                            src={item.priority == 0
                                                                                ? ticketresolvedticker
                                                                                : item.priority == 1
                                                                                    ? ticketreviewsticker
                                                                                    : ticketinprogressticker}
                                                                        // src={TicketBox}
                                                                        />
                                                                    </div>
                                                                    <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                        <div className='ticket-itemCols'>

                                                                            <h6>
                                                                                <span className="LastNumberOftickets"> {`I-${lastFourDigits}`}</span>
                                                                                {item?.department_id?.department_name
                                                                                    ? truncateText(
                                                                                        capitalizeEachWord(` - ${item?.department_id?.department_name.toLowerCase()}`),
                                                                                        40
                                                                                    )
                                                                                    : ""}

                                                                            </h6>
                                                                            <span className="text-muted DateFields">


                                                                                {item?.internal_category_id?.name ? truncateText(capitalizeEachWord(`${item?.internal_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </>
                                            :
                                            <div>

                                                <div className="Dusbinback">

                                                    <div>
                                                        <img src={boximg} />
                                                        <p className="text-center">{"No Tickets Available"}</p>

                                                    </div>
                                                </div>
                                            </div>
                                        }




                                    </div>
                                </div>

                            </>
                        }


                    </div>


                    <div className='col-5 FirstCards'>

                        <div className="col-5 Recentcard2">

                            <div className="card ClientDetailsCards">
                                <div className='TickerSTatementHeaders'>
                                    <h5>Nearing Due</h5>
                                    <div className="HaveNearduedateilsall">
                                        <button
                                            onClick={() => MoveTotheNextNeardue()}
                                        >View All</button>
                                    </div>
                                </div>
                                <div className="d-flex Recentcard2contact flex-column gap-3">
                                    <div className='ContainsTickets'>

                                        {state.NeadueInternalTicketCalls.TicketingInternalNearduedata.length != 0 ?
                                            <>
                                                {state.NeadueInternalTicketCalls.TicketingInternalNearduedata != undefined && state.NeadueInternalTicketCalls.TicketingInternalNearduedata.map((item, index) => {
                                                    const ticketid = item.id;
                                                    const lastFourDigits = item?.ticket_number;


                                                    return (
                                                        <>
                                                            <div className={`containsticketprocess mt-3 ${index == 0 ? "FirstCLient" : ""}`} key={index}>


                                                                <div className="ticket-item  ticket-itemclient  mb-1" onClick={() => {
                                                                    HandleTheNeardueTickets(item)
                                                                }}>
                                                                    <div className="InnertClientLists">
                                                                        <div className="PriorityImgs" >
                                                                            <img
                                                                                src={item.priority == 0
                                                                                    ? ticketresolvedticker
                                                                                    : item.priority == 1
                                                                                        ? ticketreviewsticker
                                                                                        : ticketinprogressticker}
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                            <div className='ticket-itemColsnear'>

                                                                                <h6>
                                                                                    <span className="LastNumberOftickets"> {`I-${lastFourDigits}`}</span>
                                                                                    {item?.department_id?.department_name ? truncateText(capitalizeEachWord(` - ${item?.department_id?.department_name.toLowerCase()}`), 40) : ""}</h6>
                                                                                <span className="text-muted DateFields">
                                                                                    {item?.internal_category_id?.name ? truncateText(capitalizeEachWord(`${item?.internal_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                </span>
                                                                            </div>

                                                                        </div>

                                                                    </div>


                                                                    <div className={`${remainingTime == 0 || (formatDate(new Date()) != formatDate(item?.created_at)) ? "dayasclolosr" : " dayasclolosr"}`}>

                                                                        <p className="HeaderoftheDatefileds Dashboardneardues">


                                                                            {overdueFunctions(item) != "Overdue" ?
                                                                                <Stack spacing={2} direction="row">
                                                                                    <CircularProgress variant="determinate"


                                                                                        value={
                                                                                            (() => {
                                                                                                const response = overdueFunctions(item); // Get the response
                                                                                                let percentage = 0; // Default to 0


                                                                                                if (response && response.includes("Minutes left")) {
                                                                                                    const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                                                                    // Extract the remaining time from the text (in minutes)
                                                                                                    const minutesLeft = Number(rest.join(""));
                                                                                                    const totalTAT = item?.department_users?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                    // console.log(minutesLeft, typeof minutesLeft, isNaN(minutesLeft), "oasiudopasidopaisd minutesLeft", totalTAT, minutesLeft, Math.min((minutesLeft / totalTAT) * 100, 100));


                                                                                                    // Ensure the minutesLeft is a valid number
                                                                                                    if (isNaN(minutesLeft)) {
                                                                                                        console.error("Invalid minutesLeft value:");
                                                                                                        return percentage; // Return 0 if invalid
                                                                                                    }


                                                                                                    if (isNaN(totalTAT)) {
                                                                                                        console.error("Invalid totalTAT value:", totalTAT);
                                                                                                        return percentage; // Return 0 if invalid
                                                                                                    }
                                                                                                    if (totalTAT === 1) {
                                                                                                        // Directly use minutesLeft as a percentage of 100
                                                                                                        percentage = Math.min(minutesLeft, 100);
                                                                                                    } else {
                                                                                                        // Use the usual percentage formula
                                                                                                        percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                    }

                                                                                                    // percentage = Math.min((minutesLeft / totalTAT ) * 100, 100);
                                                                                                }
                                                                                                else if (response && response.includes("Hours left")) {
                                                                                                    const [minutesText, ...rest] = response.split("Hours left");
                                                                                                    const minutesLeft = parseInt(minutesText.trim(), 10);

                                                                                                    if (isNaN(minutesLeft)) {
                                                                                                        console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                        return percentage; // Return 0 if invalid
                                                                                                    }

                                                                                                    const totalTAT = item?.department_users?.l1_user_TAT || 100;
                                                                                                    if (isNaN(totalTAT)) {
                                                                                                        console.error("Invalid totalTAT value:", totalTAT);
                                                                                                        return percentage; // Return 0 if invalid
                                                                                                    }

                                                                                                    percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                }

                                                                                                else if (response && response.includes("Days left")) {
                                                                                                    const [minutesText, ...rest] = response.split("Days left");
                                                                                                    const minutesLeft = parseInt(minutesText.trim(), 10);
                                                                                                    if (isNaN(minutesLeft)) {
                                                                                                        console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                        return percentage; // Return 0 if invalid
                                                                                                    }

                                                                                                    const totalTAT = item?.department_users?.l1_user_TAT || 100;
                                                                                                    if (isNaN(totalTAT)) {
                                                                                                        return percentage;
                                                                                                    }
                                                                                                    percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                }

                                                                                                console.log(percentage, "aspdopasidoasd percentage", response);

                                                                                                return percentage;
                                                                                            })()
                                                                                        }
                                                                                        style={{
                                                                                            borderRadius: "50%",
                                                                                            width: "59px",
                                                                                            height: "59px",
                                                                                            background: "transparent", // Conditional background color based on the value
                                                                                            borderColor: "#F26639",
                                                                                            color: "#F26639",
                                                                                            marginRight: "-16px !important"
                                                                                        }}

                                                                                        sx={{
                                                                                            borderRadius: "50%",
                                                                                            width: "55px",
                                                                                            height: "55px",
                                                                                            backgroundColor: "transparent", // Conditional background color
                                                                                            // border: "2px solid", // Border width
                                                                                            borderColor: 90 === 90 ? "#F26639" : "gray", // Conditional border color
                                                                                        }}
                                                                                    />

                                                                                    <span className="HeaderoftheDatefiledsNameDashboard">
                                                                                        {(() => {
                                                                                            const response = overdueFunctions(item); // Get the response

                                                                                            if (response) {
                                                                                                // Check for specific time-related keywords
                                                                                                if (response.includes("Minutes left")) {
                                                                                                    const [minutesText, ...rest] = response.split("Minutes left"); // Split the response

                                                                                                    return <> <span>{rest.join("")}</span><span className="MinutesLeft">

                                                                                                        {"Minutes"}</span></>


                                                                                                } else if (response.includes("Hours left")) {
                                                                                                    const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                                                                    const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value
                                                                                                    return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                        {"Hours"}</span></>
                                                                                                } else if (response.includes("Days left")) {
                                                                                                    const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                                                                    const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value
                                                                                                    return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                        {"Days"}</span></>

                                                                                                } else if (response === "Overdue") {
                                                                                                    return <span className="OverdueText">Overdue</span>;
                                                                                                }
                                                                                            }

                                                                                            return null; // Render nothing if response is not defined
                                                                                        })()}

                                                                                    </span>
                                                                                </Stack>
                                                                                :
                                                                                <span className="OverdueText">Overdue</span>}


                                                                        </p>


                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </>
                                            :
                                            <>
                                                <div>

                                                    <div className="Dusbinback Dusbinbackneardues">

                                                        <div>
                                                            <img src={boximg} />
                                                            <p className="text-center">{"No Tickets Nearing Due"}</p>

                                                        </div>
                                                    </div>
                                                </div>
                                            </>}




                                    </div>




                                </div>
                            </div>
                        </div>
                    </div>

                </div>
{state.ClientBranchIDs.SUBROLE ==  3 && (

                <div class="row align-items-center" style={{margin:"27px 7px"}}>
                   
                 <div className="col-12">
                        <Internal_dashboardTable  
                        range={range}
                        datas={datas}
                        department={Client}
                        priority={PriorityValues}
                        status={SttausValues}
                        date={DateFilters}
                    />
                   </div>
                                    <div className="col-12">
                        <Statebasedinternaldash  
                        range={range}
                        datas={datas}
                        department={Client}
                        priority={PriorityValues}
                        status={SttausValues}
                        date={DateFilters}
                    />
                   </div>

                    <div className="col-12">
                    <Internalescalationdash 
                                            datas={datas}
                        department={Client}
                        priority={PriorityValues}
                        status={SttausValues}
                        date={DateFilters}/>
                        
                   </div>


                    </div>

)}


              </div>


  
            {TicketListpoup && (
                <div className="RoleCreatePopup">
                    <div className="BeforePopUp">
                        <div className="RolePopups" style={{ width: "70%" }}>
                            <div className="asds">
                                <div class="ModalHeaderTicketlistviews" style={{ background: "#f79c37", display: "flex", justifyContent: "space-between", border: "none", color: "#fff", alignItems: "center" }}>
                                    <span className="TicketSummaryname" >Ticket Summary</span>

                                    <div className="CloseIcon" onClick={(e) => {
                                        setticketlistPopup(false);
                                    }}>
                                        <CloseOutlinedIcon className="CloseIconsListed" />
                                    </div>
                                </div>
                                <div className="row RecentTicket RecentTicketPopups mb-3" style={{ padding: "0 !important" }}>
                                    <div className="col RecentcardTickets mb-3">

                                        <div className="card p-3">

                                            {/* <div className='TickerSTatementHeaders'>
                                        <h5>Ticket Summary</h5>
                                        <button onClick={() => MoveTotheNextTab()}>View All</button>
                                    </div> */}

                                            <p className='Borderpara'></p>
                                            <div className="GroupofButtons">
                                                <div className="Groupbtn mb-3">
                                                    <button
                                                        className={`btn ${activeButton === "All" ? "active" : ""}`}
                                                        onClick={() => handleButtonClick("All")}
                                                    >
                                                        All
                                                    </button>
                                                    <button
                                                        className={`btn ${activeButton === "Open" ? "active" : ""}`}
                                                        onClick={() => handleButtonClick("Open")}
                                                    >
                                                        Open
                                                    </button>
                                                    <button
                                                        className={`btn ${activeButton === "Inprocess" ? "active" : ""}`}
                                                        onClick={() => handleButtonClick("Inprocess")}
                                                    >
                                                        In Progress
                                                    </button>



                                                    <button
                                                        className={`btn ${activeButton === "Completed" ? "active" : ""}`}
                                                        onClick={() => handleButtonClick("Completed")}
                                                    >
                                                        Review
                                                    </button>
                                                    <button
                                                        className={`btn ${activeButton === "over_due" ? "active" : ""}`}
                                                        onClick={() => handleButtonClick("over_due")}
                                                    >
                                                        Over Due
                                                    </button>

                                                    <button
                                                        className={`btn ${activeButton === "Rejected" ? "active" : ""}`}
                                                        onClick={() => handleButtonClick("Rejected")}
                                                    >
                                                        Rejected
                                                    </button>

                                                    <button
                                                        className={`btn ${activeButton === "Reopen" ? "active" : ""}`}
                                                        onClick={() => handleButtonClick("Reopen")}
                                                    >
                                                        Reopened
                                                    </button>

                                                    <button
                                                        className={`btn ${activeButton === "Close" ? "active" : ""}`}
                                                        onClick={() => handleButtonClick("Close")}
                                                    >
                                                        Resolved
                                                    </button>
                                                </div>
                                                <button className="ViewAllButtons" onClick={() => MoveTotheNextTab()}>View All</button>

                                            </div>


                                            <div className='ContainsTickets'>

                                                {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.length != 0 ?
                                                    <>
                                                        {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData != undefined && state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.map((item, index) => {
                                                            const ticketid = item.id;
                                                            const lastFourDigits = item?.ticket_number;


                                                            return (
                                                                <>
                                                                    <div className='containsticketprocess mt-3' key={index}
                                                                        onClick={() => { HandleTheNeardueTickets(item) }}
                                                                    >
                                                                        <span className="priority-label inprocess"

                                                                            style={{
                                                                                background: item.status == 0 ? "hsla(170, 75%, 41%, 1)" : // Open - light background
                                                                                    item.status == 1 ? "hsla(32, 92%, 59%, 1)" : // In Progress - yellow background
                                                                                        item.status == 2 ? "hsla(170, 75%, 41%, 1)" : // Completed - light green background
                                                                                            item.status == 3 ? "hsla(140, 82%, 39%, 1)" : // Close - light green background for Close
                                                                                                "hsla(11, 85%, 54%, 1)", // Default for Reopen - light red background
                                                                                color: "#fff",
                                                                            }}

                                                                        >

                                                                            {item.status == 0 ? "Open" :
                                                                                item.status == 1 ? "In Progress" :
                                                                                    item.status == 2 ? "Review" :
                                                                                        item.status == 3 ? "Resolved" : "Reopened"}</span>

                                                                        {item.status == 3 ? null :

                                                                            <span className="OverDuedashboardparts">
                                                                                {overdueFunctions(item)}
                                                                            </span>
                                                                        }


                                                                        <div className="ticket-item mb-2">

                                                                            <div className="PriorityImgs" >
                                                                                <img
                                                                                    src={item.priority == 0
                                                                                        ? ticketresolvedticker
                                                                                        : item.priority == 1
                                                                                            ? ticketreviewsticker
                                                                                            : ticketinprogressticker}
                                                                                // src={TicketBox}
                                                                                />
                                                                            </div>
                                                                            <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                                <div className='ticket-itemCols'>

                                                                                    <h6>
                                                                                        <span className="LastNumberOftickets"> {`I-${lastFourDigits}`}</span>
                                                                                        {item?.department_id?.department_name
                                                                                            ? truncateText(
                                                                                                capitalizeEachWord(` - ${item?.department_id?.department_name.toLowerCase()}`),
                                                                                                40
                                                                                            )
                                                                                            : ""}

                                                                                    </h6>
                                                                                    <span className="text-muted DateFields">


                                                                                        {item?.internal_category_id?.name ? truncateText(capitalizeEachWord(`${item?.internal_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                    </span>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </>
                                                    :
                                                    <div>

                                                        <div className="Dusbinback">

                                                            <div>
                                                                <img src={boximg} />
                                                                <p className="text-center">{"No Tickets Available"}</p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                }




                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            )}







        </>

    )
}

export default InternalDashboardusers

